import cx from 'classnames';

type Props = {
  colorScheme?: 'white' | 'light' | 'dark';
  children: React.ReactNode;
  gap?: string;
};

const SectionWrapper = ({
  colorScheme = 'white',
  children,
  gap = 'lg:gap-8',
}: Props) => {
  const theme = {
    white: 'color-scheme-white',
    light: 'color-scheme-light',
    dark: 'color-scheme-dark',
  }[colorScheme];

  return (
    <div
      data-testid="storefront-row"
      className={cx(
        'relative max-w-8xl shrink-0 justify-center bg-surface lg:grid lg:grid-cols-12 xl:w-full',
        'mx-4 my-16 p-8 md:mx-6 md:my-20 lg:mx-16 lg:my-24 lg:p-16 xl:mx-auto xl:my-32',
        gap,
        theme,
        colorScheme === 'white' && '',
        colorScheme === 'dark' && 'rounded-md',
        colorScheme === 'light' && 'rounded-md',
      )}
    >
      {children}
    </div>
  );
};

export default SectionWrapper;
